import { Injectable } from '@angular/core';
import { Component, HostBinding } from '@angular/core';
import { NbToastrService, NbGlobalLogicalPosition, NbComponentStatus } from '@nebular/theme';
import { MessageType } from '../@core/common/models/notification.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {

  constructor(private toastr: NbToastrService) { }
  showNotification(type: MessageType, content: string) {
    let status: NbComponentStatus = 'danger';

    if (!content)
      return;
    switch (type) {
      case MessageType.SUCCESS:
        const statusSuccess: NbComponentStatus = 'success';
        status = statusSuccess;
        this.toastr.show(content, MessageType.SUCCESS,
          { position: NbGlobalLogicalPosition.TOP_END, limit: 5, icon: '', iconPack: 'eva', status });
        break;
      case MessageType.ERROR:
        this.toastr.show(content, MessageType.ERROR, {
          position: NbGlobalLogicalPosition.TOP_END, limit: 5, icon: '', iconPack: 'eva', status });
        break;
      case MessageType.CONECTION_ERROR:
        this.toastr.show(content, MessageType.ERROR, {
          position: NbGlobalLogicalPosition.TOP_END, limit: 5, icon: '', iconPack: 'eva', status });
        break;
      case MessageType.INFO:
        const infoStatus: NbComponentStatus = 'info';
        status = infoStatus;
        this.toastr.show(content, MessageType.INFO, {
          position: NbGlobalLogicalPosition.TOP_END, limit: 5, icon: '', iconPack: 'eva', status });
        break;
        case MessageType.WARNING:
        const warningStatus: NbComponentStatus = 'warning';
        status = warningStatus;
        this.toastr.show(content, MessageType.WARNING, {
          position: NbGlobalLogicalPosition.TOP_END, limit: 5, icon: '', iconPack: 'eva', status });
        break;
      default:
        break;
    }
  }
}
